export const isProductionEnv = process.env.ENVIRONMENT === 'production'

export const isStagingEnv = process.env.ENVIRONMENT === 'staging'

export const isDevServerEnv = process.env.ENVIRONMENT === 'devserver'

export const isDevelopmentEnv = process.env.ENVIRONMENT === 'development'
